/**
 * Styles.
 */
import './style.scss';

import React, { useEffect } from 'react';
import _ from 'lodash';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { Row, Col, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';

import { GQL_GET_SPENDING_PAGE } from '../../gqls';
import { updatePaginatedData } from '../../utils';
import { paymentLinkDetails } from '../../actions/payment-links';
import { isInternalUserOnly } from '../Settings/configs/role-config';
import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageTitle from '../../components/page-title';
import PageContent from '../../components/page-content';
import NavigationTopRight from '../../components/navigation-top-right';

const MoneyTransferDetail = () => {
  const currentUser = useSelector(state => state.currentUser);

  if (!isInternalUserOnly(currentUser)) {
    return (window.location.href = process.env.REACT_APP_BASE_URL);
  }

  const upl = useSelector(state => state.updatePaymentLinks);
  const dispatch = useDispatch();
  const { id } = useParams();
  const gparam = { search: { id: [{ operator: 'eq', value: id }] } };
  const { loading, error, data, fetchMore } = useQuery(GQL_GET_SPENDING_PAGE, {
    variables: gparam
  });

  const spending = _.get(data, 'getSpendingPage.items[0]');
  if (spending) {
    dispatch(paymentLinkDetails(spending));
  }

  const updateData = () => {
    fetchMore({
      variables: gparam,
      updateQuery: (previousResult, { fetchMoreResult }) =>
        updatePaginatedData('getSpendingPage', previousResult, fetchMoreResult),
      notifyOnNetworkStatusChange: true
    });
  };

  useEffect(() => {
    updateData();
  }, [upl]);

  if (error) return `Error! ${error.message}`;
  if (loading) return <Spinner />;

  if (data?.getSpendingPage?.items?.length === 0) {
    window.location.href = process.env.REACT_APP_BASE_URL;
  }

  return (
    <PageWrap>
      <PageTitle className="d-none d-sm-block" breadcrumbs={{ '/': currentUser?.name || 'Detail Pengiriman Payroll' }}>
        <Row className="mb-0">
          <Col md="4">
            <h1>Payroll Detail {spending?.id?.substring(0, 6)}</h1>
          </Col>
          <Col md="8" className="text-right">
            <NavigationTopRight />
          </Col>
        </Row>
      </PageTitle>
      <PageContent>
        <AsyncComponent component={() => import('./content')} />
      </PageContent>
    </PageWrap>
  );
};

export default MoneyTransferDetail;
